// extracted by mini-css-extract-plugin
export default {"textfield":"teacher_textfield__iqpXo","scrollable":"teacher_scrollable__r32Uh"};